<template>

  <!---loader--->
  <span v-if="loading">
        <v-skeleton-loader type="text" width="100%" height="20px" class="mt-2"></v-skeleton-loader>
        <v-skeleton-loader type="text" width="100%" height="20px" class="mt-2"></v-skeleton-loader>
      </span>
  <div v-else>
    <div v-html="text"></div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["shouhinNaiyou"],
  watch: {
    shouhinNaiyou: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.getTextThumb();
        }
      }
    }
  },
  data() {
    return {
      text: null,
      loading: true
    }
  },
  created() {
  },
  methods: {
    async getTextThumb() {
      try {
        this.loading = true;
        const res = await axios.get(this.novelPickPath + "/" + this.shouhinNaiyou);
        if (res.data) {
          this.text = res.data + "…";
          this.loading = false;
        }
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },
};
</script>
